export enum EstateStatusEnum {
  pending = 'PENDING',
  active = 'ACTIVE',
  inactive = 'INACTIVE',
  blocked = 'BLOCKED',
  update = 'UPDATE',
}
